// ATE-CR-117 — task 11 FIX: backend returns paginated `{items: Tenant[], ...}` envelope
// per `PaginatedResponse[TenantSummary]`. Unwrap on the client so callers keep
// the existing `Tenant[]` contract.
import { fetchApi } from "@/api/client";
import type { Tenant } from "@/types/tenants";

export const API_TENANTS_PATH = "/api/tenants" as const;

// ATE-CR-117 — backend envelope for /api/tenants list endpoint.
interface TenantsListResponse {
  readonly items: Tenant[];
  readonly total: number;
  readonly page: number;
  readonly page_size: number;
  readonly total_pages: number;
}

// ATE-CR-117 — task 11 FIX
export async function listTenants(signal?: AbortSignal): Promise<Tenant[]> {
  const response = await fetchApi<TenantsListResponse>(API_TENANTS_PATH, { signal });
  return response.items;
}
